import { render, staticRenderFns } from "./PolicyEditCustomCombination.vue?vue&type=template&id=149393b9&scoped=true&"
import script from "./PolicyEditCustomCombination.vue?vue&type=script&lang=js&"
export * from "./PolicyEditCustomCombination.vue?vue&type=script&lang=js&"
import style0 from "./PolicyEditCustomCombination.vue?vue&type=style&index=0&id=149393b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149393b9",
  null
  
)

export default component.exports